'use client'

/**
 * CTA affiché à la place du bouton de lancement quand un module est
 * indisponible pour un utilisateur du plan gratuit.
 *
 * Deux variantes :
 *  - 'locked'    → un autre module gratuit a déjà été utilisé (ou module
 *                  réservé Pro). Fond vert « Passer en Pro » — ce n'est pas
 *                  une limite atteinte, juste une invitation à passer Pro.
 *  - 'exhausted' → les crédits gratuits de CE module sont réellement épuisés.
 *                  Fond rouge « Limite atteinte ».
 */
interface UpgradeBlockedCTAProps {
  variant: 'locked' | 'exhausted'
  onUpgrade: () => void
  /** Alignement du bloc — par défaut centré. */
  align?: 'center' | 'flex-end' | 'flex-start'
}

export default function UpgradeBlockedCTA({ variant, onUpgrade, align = 'center' }: UpgradeBlockedCTAProps) {
  const isExhausted = variant === 'exhausted'
  const textAlign: 'center' | 'right' | 'left' =
    align === 'flex-end' ? 'right' : align === 'flex-start' ? 'left' : 'center'

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: align, gap: 5 }}>
      <button
        onClick={onUpgrade}
        style={{
          padding: '9px 18px',
          borderRadius: 8,
          fontSize: 13,
          fontWeight: 700,
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
          fontFamily: 'inherit',
          background: isExhausted ? '#DC2626' : '#1B4332',
        }}
      >
        {isExhausted ? 'Limite atteinte' : 'Passer en Pro'}
      </button>
      <span style={{ fontSize: 11, color: '#6B7280', lineHeight: 1.45, maxWidth: 280, textAlign }}>
        {isExhausted
          ? 'Vous avez utilisé tous vos crédits gratuits. Passez à Qualyse Pro pour continuer en accès illimité.'
          : 'Passez à Qualyse Pro pour bénéficier de tous les modules en accès illimité.'}
      </span>
    </div>
  )
}
